// extracted by mini-css-extract-plugin
export default {"ContentFeaturePaymentSummaryBadge":"ContentFeaturePaymentSummaryBadgejVxJd","contentFeaturePaymentSummaryBadge":"ContentFeaturePaymentSummaryBadgejVxJd","badge":"badgeQNqRd"};